import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20movie%20theater%20interior%20with%20curved%20projection%20screen%20and%20comfortable%20red%20velvet%20seats%2C%20dramatic%20stage%20lighting%20with%20warm%20golden%20and%20deep%20red%20ambiance%2C%20art%20deco%20design%20elements%2C%20grand%20architecture%2C%20atmospheric%20fog%2C%20premium%20cinema%20experience&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="爱丫爱丫影院 - 高清电影免费在线观看"
          title="爱丫爱丫影院 - 流畅播放秒开看剧"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="w-full max-w-[800px]">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            流畅播放 秒开看剧
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-3 max-w-[600px] mx-auto">
            无广告不缓冲 · 极速观影 · 不卡顿
          </p>
          <p className="text-sm md:text-base text-white/60 mb-8 max-w-[500px] mx-auto">
            高清电影免费在线观看，海量免费电视剧，每日更新
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/zuixin"
              className="px-8 py-3.5 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观影
            </Link>
            <Link
              to="/category/gaofen"
              className="px-8 py-3.5 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-semibold hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer border border-white/20"
            >
              <i className="ri-star-line mr-2"></i>
              高分推荐
            </Link>
          </div>

          {/* Stats */}
          <div className="flex items-center justify-center gap-8 md:gap-12 mt-12">
            {[
              { value: '10万+', label: '影视资源' },
              { value: '99.9%', label: '播放成功率' },
              { value: '5000万+', label: '月活用户' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400">{stat.value}</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-xs text-white/40">向下探索</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/40 text-sm animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}